import { IMeasureFilterState } from '../types';
import {
  IMeasureFilterFieldsFragment,
  IRelationalOperator,
  RelationalOperatorKey,
} from '../../../../../../utils/apollo/graphqlSchema';
import { assertNotNil } from '../../../../../../utils/types';
import { IMeasureFilterValue } from '../../../../../../redux/slices/oldBuilder';

const prepareMeasureFilterSubmitData = (
  formData: IMeasureFilterState,
  options: IMeasureFilterValue[],
  defaultMeasureRelOps: IRelationalOperator[],
): IMeasureFilterValue[] => {
  return options.reduce<IMeasureFilterValue[]>((acc, option) => {
    const { rowMeta, measureKey } = option;
    const { rowType, rowIndex } = rowMeta;

    const formValue = formData.filters.find(
      (filter) => filter?.measureKey === measureKey,
    );

    if (formValue) {
      const { relOpKey, value, fromValue, toValue } = formValue;

      assertNotNil(relOpKey);

      const values: IMeasureFilterFieldsFragment['values'] = [];

      if (relOpKey === RelationalOperatorKey.Between) {
        assertNotNil(fromValue);
        assertNotNil(toValue);

        values.push(fromValue, toValue);
      } else {
        assertNotNil(value);

        values.push(value);
      }

      const relOp = defaultMeasureRelOps.find(
        (relOp) => relOp.key === relOpKey,
      );
      assertNotNil(relOp);

      acc.push({
        rowMeta: {
          rowType,
          rowIndex,
        },
        measureKey,
        filter: {
          __typename: 'MeasureFilter',
          relOp,
          values,
        },
      });
    }

    return acc;
  }, []);
};

export default prepareMeasureFilterSubmitData;
